import numeral from 'numeral';

const keys = (t) => [
    {
        key: 'clicks',
        label: t('search.directories_details.chart.avg_clicks'),
        icon: 'clicks',
        yAxisID: 'y3',
    },
    {
        key: 'impressions',
        label: t('search.directories_details.chart.avg_impressions'),
        icon: 'search',
    },
    {
        key: 'position',
        label: t('search.directories_details.chart.avg_position'),
        icon: 'pagev-view',
        yAxisID: 'y2',
    },
    {
        key: 'ctr',
        label: t('search.directories_details.chart.avg_ctr'),
        format: '0.00%',
        yAxisID: 'y1',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'ctr',
    },
    {
        key: 'keywords',
        label: t('search.directories_details.chart.avg_keywords'),
        icon: 'pagev-view',
    },
    {
        key: 'urls',
        label: t('search.directories_details.chart.avg_pages'),
        icon: 'pagev-view',
    },
];

export default keys;
